import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {searchTills} from "./actions";
import {Link} from "react-router-dom";
import ListView from "../common/ListView";

class TillsPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    dispensaryId: PropTypes.string,
    search: PropTypes.object.isRequired,
    searchTills: PropTypes.func.isRequired,
  };

  static defaultProps = {
    dispensaryId: null
  };

  render() {
    const {
      history, searchTills, dispensaryId,
      search: {searching, pagination, filters, sorter, searchFilter, results},
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        className: 'one-line-column',
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        sorter: true,
      },
      {
        title: 'Action',
        key: 'action',
        fixed: 'right',
        width: 75,
        render: (_, {tillId}) => <Link to={`/till/update/${encodeURIComponent(tillId)}`}>Edit</Link>,
      }
    ];
    return (
      <ListView
        dispensaryId={dispensaryId}
        title="Tills"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchTills}
        dataSource={results}
        pagination={pagination}
        searchFilter={searchFilter}
        filters={filters}
        sorter={sorter}
        onAdd={() => history.push('/till/add')}
        rowKey="tillId"
      />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.till.gettingTills,
  dispensaryId: state.dispensary.selectedDispensaryId,
  search: state.till.search,
});

const mapDispatchToProps = dispatch => ({
  searchTills: payload => (dispatch(searchTills(payload)))
});

export default connect(mapStateToProps, mapDispatchToProps)(TillsPage);


// WEBPACK FOOTER //
// ./src/Till/TillsPage.js